


















































































import { Component, Vue, Watch } from 'vue-property-decorator';

import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import DatePicker from '@/components/DatePicker.vue';

import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

import FormInput from '@/components/FormInput.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import ReportTable from './PartnershipTable.vue';
import BalanceJumbotron from './components/BalanceJumbotron.vue';

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    BalanceJumbotron,
    ReportTable,
    SearchIcon,
    ExportIcon,
    SearchRow,
    SearchField,
    DatePicker,
    Select,
    FormInput,
  },
})

export default class Partnership extends Vue {
  $refs!: {
    report: ReportTable;
  }

  partnerName: LabelValue | null = null;
  partnerNameOptions: LabelValue[] = [
    {
      label: 'Oy!',
      value: 'Oy!',
    },
    {
      label: 'flip',
      value: 'flip',
    },
  ];

  token = '';
  totalBalance = 0;
  searchOpen = false;

  loading = true;
  loadingExport = false;

  mounted() {
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  parseParams() {
    const params = this.$route.query;

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    if (typeof params.partner_name === 'string') {
      this.partnerName = {
        label: '',
        value: params.partner_name,
      };
    }

    this.getPartnership(page);
  }

  getPartnership(page: number) {
    const params = {
      page,
      name: this.partnerName?.value,
      export: this.loadingExport,
    };

    try {
      return this.$refs.report.getPartnership(params);
    } catch (err) {
      this.loading = false;
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to search partner');
    }

    return null;
  }

  updateTotalBalance(balance: number) {
    this.totalBalance = balance;
  }

  updateLoading(loading: boolean) {
    this.loading = loading;
  }

  // toggleSearchOpen() {
  //   this.searchOpen = !this.searchOpen;
  // }

  // cancel() {
  //   this.$router.push({
  //     query: {},
  //   });
  // }

  // search() {
  //   this.$router.push({
  //     query: {
  //       // eslint-disable-next-line @typescript-eslint/camelcase
  //       partner_name: this.partnerName?.value,
  //     },
  //   });
  // }

  // async exportPartnership() {
  //   this.loadingExport = true;
  //   if (this.partnerName !== null) {
  //     showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

  //     try {
  //       const path = await this.getPartnership(1, true);
  //       this.downloadSheet(path as string);
  //       showToast(ToastType.SUCCESS, 'Success', 'Export merchant account state success');
  //     } catch (err) {
  //       showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to download sheet');
  //     }
  //   } else {
  //     showToast(ToastType.FAILED, 'Oops… Sorry', 'Please select Partner first');
  //   }
  //   this.loadingExport = false;
  // }

  // // eslint-disable-next-line class-methods-use-this
  // async downloadSheet(path: string | null) {
  //   const fileLink = document.createElement('a');
  //   fileLink.href = `${process.env.VUE_APP_API_URL}${path}`;
  //   fileLink.setAttribute('download', 'report.xlsx');

  //   document.body.appendChild(fileLink);
  //   fileLink.click();
  // }
}
